/**
 * @module role.transformer
 */
import { permissionsFrom } from './permission.transformer';

const roleFrom = (rawRole) => {
  // We only support one name at this moment, so translations doesn't matter too much
  // @ts-expect-error TS(2571): Object is of type 'unknown'.
  const name = Object.values(rawRole?.translations)[0]?.name || '';
  const globalActions =
    rawRole.permissions.globalActionIds?.map((id) => ({
      globalActionId: id,
    })) || [];
  const adminPermissions = [];

  const permissions = permissionsFrom(globalActions, rawRole.permissions.surveyTypes, adminPermissions);

  const role = {
    id: rawRole.id,
    userIds: rawRole.userIds,
    totalUsers: rawRole.userIds.length,
    companyId: rawRole.companyId,
    name,
    permissions,
    translations: rawRole.translations,
    kazooDefaultRole: rawRole.kazooDefaultRole,
  };

  return role;
};

/**
 * Map list of roles returned by server to usable format by front-end UI.
 *
 * @example roles (from server)
 * [
 *   {
 *     "id": 123,
 *     "companyId": "1",
 *     "permissions": { globalActionIds: [], surveyTypes: []},
 *     "translations": { en-ca: { name: '123' } }
 *     }
 *   }
 * ]
 */
const rolesFrom = (rawRoles = []) => {
  const roles = rawRoles.map((rawRole) => roleFrom(rawRole));

  return roles;
};

export { roleFrom, rolesFrom };
